var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass:
        "form-fields-companies-list flex-row jc-space py-3 px-2 ai-center fs-3 lh-20",
      class: { cpointer: _vm.enabled },
      on: {
        click: function($event) {
          return _vm.selectCompany(_vm.company)
        }
      }
    },
    [
      _c("div", { staticClass: "flex-row ai-center" }, [
        _c(
          "div",
          { staticClass: "form-fields-companies-list--icon mr-2" },
          [
            _c(
              "icon-svg",
              {
                attrs: {
                  "icon-name": _vm.third,
                  width: 32,
                  height: 32,
                  viewBox: "0 0 32 32"
                }
              },
              [_c("icon-" + _vm.third, { tag: "component" })],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex-column lh-20",
            class: { "pl-2": _vm.allowRemove && !_vm.overview }
          },
          [
            _c(
              "div",
              { staticClass: "form-fields-companies-list--company-name" },
              [
                _vm.third === "individual"
                  ? _c("strong", [
                      _vm._v(
                        _vm._s(_vm.civility) +
                          " " +
                          _vm._s(_vm.company.name) +
                          " " +
                          _vm._s(_vm.company.forename)
                      )
                    ])
                  : _c("strong", [
                      _vm._v(_vm._s(_vm._f("upperCase")(_vm.company.name)))
                    ]),
                _vm._v(" "),
                _vm.allowBadge
                  ? _c("badge", {
                      attrs: {
                        dot: "",
                        inline: "",
                        tooltip: "",
                        badges: _vm.badge(_vm.company)
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.allowRemove && !_vm.overview
              ? _c(
                  "span",
                  { staticClass: "gray-60 ellipsis wp-10 max-size-item" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.postalCode) +
                        "\n                " +
                        _vm._s(_vm._f("upperCase")(_vm.city)) +
                        "\n            "
                    )
                  ]
                )
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      !_vm.allowRemove && !_vm.overview
        ? _c("span", { staticClass: "gray-60 aleft no-wrap" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.postalCode) +
                "\n        " +
                _vm._s(_vm._f("upperCase")(_vm.city)) +
                "\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.overview || _vm.allowEdit || _vm.allowRemove
        ? _c(
            "div",
            { staticClass: "flex-row jc-space" },
            [
              _vm.allowEdit
                ? _c(
                    "a",
                    {
                      staticClass:
                        "aright fs-3 hover-primary-100 semibold nowrap self-center",
                      attrs: {
                        href: "javascript:;",
                        "data-bot": _vm.getDatabot(
                          "edit",
                          _vm.dataBotsContext,
                          null,
                          "company"
                        )
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("edit-company", _vm.company)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$l10n.__("Modifier")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.allowRemove
                ? _c(
                    "a",
                    {
                      staticClass:
                        "aright fs-3 hover-primary-100 semibold nowrap self-center",
                      attrs: {
                        href: "javascript:;",
                        "data-bot": _vm.getDatabot(
                          "cancel",
                          _vm.dataBotsContext,
                          null,
                          "company"
                        )
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("remove-company")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$l10n.__("Annuler")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.overview
                ? _c(
                    "router-link",
                    {
                      staticClass:
                        "aright fs-3 ml-3 hover-primary-100 semibold nowrap self-center cpointer hover-primary-100",
                      attrs: { to: _vm.routerLinkParams(), target: "_blank" }
                    },
                    [_vm._v(_vm._s(_vm.toOverViewLabel))]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }